import DisplayedTimeFormat from '@/components/DisplayedTimeFormat/DisplayedTimeFormat.vue';
import { getTimeData } from '@/utils/helper';

export default {
  name: 'OrderCompleted',
  components: {
    DisplayedTimeFormat,
  },
  data() {
    return {
      infos: {},
      items: [],
    };
  },
  created() {
    const {
      infos = {},
      items = [],
    } = this.$route?.params || {};

    if (!Object.keys(infos).length || !items.length) {
      this.$router.push('/login');
      return;
    }

    this.infos = infos;
    this.items = items;
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
  methods: {
    getTimeData,
    onClickPrint() {
      window.print();
    },
  },
};
